import React from 'react';
import { I18n } from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import { AuthPiece } from 'aws-amplify-react';
import validate from './Validate';

// HACK:
// Needed to use different import for these UI-component as they are
// not defined as exports within the global scope of the component.
import {
  Button,
  FormField,
  FormSection,
  Input,
  InputLabel,
  Link,
  SectionBody,
  SectionFooter,
  SectionFooterPrimaryContent,
  SectionFooterSecondaryContent,
  SectionHeader,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';

export default class SignUp extends AuthPiece {
  constructor(props) {
    super(props);

    this.state = {
      btSignUpEnabled: true,
    };
    this._validAuthStates = ['signUp'];
    this.signUp = this.signUp.bind(this);
  }

  enableBtSignUp = () => {
    this.setState({
      btSignUpEnabled: true,
    });
  };

  disableBtSignUp = () => {
    this.setState({
      btSignUpEnabled: false,
    });
  };

  signUp() {
    this.disableBtSignUp();

    let { username = '', password = '', rePassword = '' } = this.inputs;
    username = username.replace(/\s/g, '').toLowerCase();
    const { error } = validate.validateInput({ username, password, rePassword, signUp: true });
    if (error) {
      this.enableBtSignUp();
      return this.error(new Error(error));
    }

    if (!Auth || typeof Auth.signUp !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }

    let signup_info = {
      username,
      password,
      attributes: {
        email: username,
      },
    };

    Auth.signUp(signup_info)
      .then(() => this.changeState('confirmSignUp', username))
      .catch((err) => this.error(err))
      .finally(() => this.enableBtSignUp());
  }

  showComponent(theme) {
    const { hide } = this.props;
    if (hide && hide.includes(SignUp)) {
      return null;
    }
    return (
      <FormSection theme={theme}>
        <SectionHeader theme={theme}>{I18n.get('Create a new account')}</SectionHeader>
        <SectionBody theme={theme}>
          <FormField theme={theme}>
            <InputLabel>{I18n.get('Email')} *</InputLabel>
            <Input
              autoFocus
              placeholder={I18n.get('Enter your email')}
              theme={theme}
              key="username"
              name="username"
              onChange={this.handleInputChange}
            />
          </FormField>
          <FormField theme={theme}>
            <InputLabel>{I18n.get('Password')} *</InputLabel>
            <Input
              placeholder={I18n.get('Create a password')}
              theme={theme}
              type="password"
              key="password"
              name="password"
              onChange={this.handleInputChange}
            />
          </FormField>
          <FormField theme={theme}>
            <InputLabel>{I18n.get('Re-enter password')} *</InputLabel>
            <Input
              placeholder={I18n.get('Re-enter password')}
              theme={theme}
              type="password"
              key="rePassword"
              name="rePassword"
              onChange={this.handleInputChange}
            />
          </FormField>
        </SectionBody>
        <SectionFooter theme={theme}>
          <SectionFooterPrimaryContent theme={theme}>
            <Button disabled={!this.state.btSignUpEnabled} onClick={this.signUp} theme={theme}>
              {I18n.get('Create Account')}
            </Button>
          </SectionFooterPrimaryContent>
          <SectionFooterSecondaryContent theme={theme}>
            {I18n.get('Have an account? ')}
            <Link color="primary" theme={theme} onClick={() => this.changeState('signIn')}>
              {I18n.get('Sign in')}
            </Link>
          </SectionFooterSecondaryContent>
        </SectionFooter>
      </FormSection>
    );
  }
}
